import React from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/Accordion';
const ITEMS = [{
  q: 'Are peptides legal to buy in the UK?',
  a: 'Yes — when sold and purchased for research purposes only. The products on peptides.ml are intended for in-vitro laboratory and research use, not for human consumption. By purchasing, you confirm you are a qualified researcher or biohacker acting in compliance with UK law.'
}, {
  q: 'What does "research use only" actually mean?',
  a: 'It means our products are sold under standard UK chemical research framing. They are not licensed medicines and we make no medical claims. We do not provide dosing or treatment advice. Consult a qualified clinician before any human use.'
}, {
  q: 'How are your peptides tested?',
  a: 'Every batch is sent to an ISO 17025-accredited third-party laboratory in the UK. We use High-Performance Liquid Chromatography (HPLC) to measure purity and mass spectrometry to confirm identity. The full certificate is published for every batch — you can view it before purchase.'
}, {
  q: 'What is HPLC and why does it matter?',
  a: 'HPLC stands for High-Performance Liquid Chromatography. It separates the components of a compound to measure exactly how much of the desired peptide is present versus contaminants. A peptide labelled 99.7% means 99.7% of the dry weight is the target peptide. We do not list a product below 99% purity.'
}, {
  q: 'How do you ship?',
  a: 'All orders ship same-day from our UK facility (Mon–Fri, before 2pm). Peptides are shipped in temperature-controlled cold-chain packaging via tracked courier. Free UK delivery on orders over £75. Packaging is plain and discreet — no branding on the outer.'
}, {
  q: 'How should I store peptides?',
  a: 'Lyophilised (freeze-dried) peptides should be stored at 2–8°C. Once reconstituted, store at 2–8°C and use within the timeframe noted on the COA. Avoid freeze-thaw cycles. Detailed storage notes are included with every order.'
}, {
  q: 'What payment methods do you accept?',
  a: 'Visa, Mastercard, American Express, and PayPal. All payments are processed through Stripe with full 3D Secure. Your card statement will show a discreet descriptor.'
}, {
  q: 'Do I need to be 18 to purchase?',
  a: 'Yes. You must be 18 or over to purchase from peptides.ml. We may verify age at checkout or before dispatch.'
}];
export function FAQ() {
  return <section id="faq" className="w-full py-20 lg:py-28 bg-secondary/40 border-y border-border" data-id="element-143">
      <div className="container mx-auto" data-id="element-144">
        <div className="grid lg:grid-cols-12 gap-12" data-id="element-145">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-4" data-id="element-146">
            <p className="text-[11px] uppercase tracking-wider text-muted-foreground font-medium mb-3" data-id="element-147">
              Questions
            </p>
            <h2 className="text-3xl lg:text-5xl font-semibold tracking-[-0.025em] text-foreground leading-[1.05]" data-id="element-148">
              Straight answers<span className="text-primary" data-id="element-149">.</span>
            </h2>
            <p className="mt-5 text-[15px] text-muted-foreground leading-relaxed" data-id="element-150">
              Can't find what you're looking for? Our team replies within one
              working hour.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="lg:col-span-8" data-id="element-151">
            <Accordion type="single" defaultValue="q-0" className="w-full" data-id="element-152">
              {ITEMS.map((item, i) => <AccordionItem key={i} value={`q-${i}`} className="border-border" data-id="element-153">
                  <AccordionTrigger className="text-left text-base font-medium hover:no-underline" data-id="element-154">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[15px] leading-relaxed text-muted-foreground" data-id="element-155">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>;
}